import PartnerConstants from "@/constants/partner/partner.constants";
import StoragePartnerConstants from "@/constants/partner/storage.constants";
import BrowserStorage from "@/services/storage/browserStorage";
import Configuration from "@/services/configuration";

const getConfigurations = function () {
  return {
    [PartnerConstants.PEDEAII]: {
      logo: () =>
        import(
          /* webpackChunkName: "Rochinha" */ "@/assets/header-rochinha.svg"
        ),

      analyticTag: Configuration?.partner?.pedeai?.analyticTag || "",
      availableProducts:
        Configuration?.partner?.pedeai?.availableProducts || {},
    },
  };
};

const getDefaultPartner = function () {
  return PartnerConstants.PEDEAII;
};

const getPartnerConfiguration = function (partner) {
  return getConfigurations()[partner?.toLowerCase()] || null;
};

const setActivePartner = function (partner) {
  BrowserStorage.set(StoragePartnerConstants.ACTIVE_PARTNER, partner);
};

const getActivePartner = function () {
  return BrowserStorage.get(StoragePartnerConstants.ACTIVE_PARTNER);
};

export default {
  getDefaultPartner,
  getPartnerConfiguration,
  setActivePartner,
  getActivePartner,
};
